import React, { useState } from 'react';
import { X, Check } from 'lucide-react';
import { useAvailableEvents, useCreateWebhook } from '../../../hooks';

export default function CreateWebhookModal({ onClose }) {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [selectedEvents, setSelectedEvents] = useState([]);

  const { data: eventsData } = useAvailableEvents();
  const createWebhook = useCreateWebhook();

  const events = eventsData?.events || [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    await createWebhook.mutateAsync({
      name,
      url,
      events: selectedEvents,
      active: true,
    });
    onClose();
  };

  const toggleEvent = (event) => {
    setSelectedEvents((prev) =>
      prev.includes(event) ? prev.filter((e) => e !== event) : [...prev, event]
    );
  };

  return (
    <div className="workbench-modal-overlay" onClick={onClose}>
      <div className="workbench-modal" onClick={(e) => e.stopPropagation()}>
        <div className="workbench-modal-header">
          <h2>Create Webhook</h2>
          <button className="workbench-modal-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="workbench-modal-body">
            <div className="form-group">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="workbench-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g., Production Webhook"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">URL</label>
              <input
                type="url"
                className="workbench-input"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://your-server.com/webhook"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Events ({selectedEvents.length} selected)</label>
              <div className="events-list">
                {events.map((event) => (
                  <label
                    key={event}
                    className={`event-checkbox ${selectedEvents.includes(event) ? 'selected' : ''}`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedEvents.includes(event)}
                      onChange={() => toggleEvent(event)}
                    />
                    <span className="event-check">
                      {selectedEvents.includes(event) && <Check size={12} />}
                    </span>
                    <span className="event-label">{event}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="workbench-modal-footer">
            <button type="button" className="workbench-btn workbench-btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="workbench-btn workbench-btn-primary"
              disabled={!name || !url || selectedEvents.length === 0 || createWebhook.isPending}
            >
              {createWebhook.isPending ? 'Creating...' : 'Create Webhook'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
